export default {"src":"/a/r/be1.10/_next/static/media/swap.4232e033.svg","height":492,"width":492,"blurWidth":0,"blurHeight":0};